// extracted by mini-css-extract-plugin
export var cardLayout = "_7z-1";
export var paginationContainer = "_7z-0";